import * as PIXI from 'pixi.js';


export default class RadialSpinner extends PIXI.Graphics 
{
    private _outerRadius: number = null;

    private _phase: number = null;



    public set outerRadius( value: number ) { this._outerRadius = value; }


    public constructor() 
    {   
        super();
    }

    public init(): void
    {
        console.assert( this._outerRadius != null, "Spinner.ts :: init() :: this._outerRadius cannot be null." );

        this._phase = 0;
    }
    
    public end(): void {}

    public setProgress( progress: number ): void
    {
        /*let isDirty: boolean = false;
        if ( progress >= 0.75 )
        {
            if ( this._curColor != this._arrColor[ 1 ] )
            {
                this._curColor = this._arrColor[ 1 ];

                isDirty = true;
            }
        }
        else if ( this._curColor != this._arrColor[ 0 ] )
        {
            this._curColor = this._arrColor[ 0 ];

            isDirty = true;
        }*/

        if ( progress == 0 )
        {
            this.visible = false;
        }
        else
        {
            this.visible = true;

            this._phase = 2 * Math.PI * progress;

            const angleStart = 0 - Math.PI / 2;
            const angle = this._phase + angleStart;

            // Calculate target point.
            const x = Math.cos(angleStart) * this._outerRadius;
            const y = Math.sin(angleStart) * this._outerRadius;
            // Redraw mask
            this.clear()
                .moveTo( 0, 0 )
                .beginFill( 0xffffff, 1 )
                .lineTo( x, y )
                .arc( 0, 0, this._outerRadius, angleStart, angle, true )
                .lineTo( 0, 0 )
                .endFill();
        }
    }
}
